import { StarListMode, StarLite } from '@apeiron/star'
import { INFO_POPUP_TYPE, InfoPopup } from '@apeiron/temp'
import { styled } from '@mui/material'
import StarListWithFilter from '@src/components/stars/list/StarListWithFilter'
import { FC, useCallback } from 'react'

const StyledInfoPopup = styled(InfoPopup)`
  ${props => props.theme.breakpoints.up('res1280')} {
    width: 80%;
  }
  ${props => props.theme.breakpoints.down('res1280')} {
    width: 100%;
  }
  height: 90%;
  max-width: 1500px;
  max-height: 1000px;
  .Custom-Content {
    overflow-y: auto;
    height: 100%;
  }
`

const StyledStarListWithFilter = styled(StarListWithFilter)`
  height: 100%;
  overflow-y: hidden;
`

const StarSelectPopup: FC<Props> = (props: Props) => {
  const { open, onClose, onSelect, postProcessData } = props

  const handleOnClose = useCallback(() => {
    if (onClose) {
      onClose()
    }
  }, [onClose])

  const handleOnSelect = useCallback(
    (star: StarLite) => {
      if (onSelect) {
        onSelect(star)
      }
    },
    [onSelect]
  )

  return (
    <StyledInfoPopup
      open={open}
      type={INFO_POPUP_TYPE.BLACK}
      onClose={handleOnClose}
    >
      <StyledStarListWithFilter
        allowFavorite={false}
        enableLink={false}
        mode={StarListMode.POPUP_SELECT_INVENTORY}
        onItemClick={handleOnSelect}
        postProcessData={postProcessData}
      />
    </StyledInfoPopup>
  )
}

type Props = {
  open: boolean
  onClose?: () => void
  onSelect?: (star: StarLite) => void
  postProcessData?: (stars: StarLite[]) => StarLite[]
}

export default StarSelectPopup
